"use client"

import { CircleParking } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleParkingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleParkingIcon = component(Icon)({ as: CircleParking })
